import React from "react";

const HeaderText = () => {

  return (
    <div className="nurse-header-text">
      스마트닥
    </div>
  );
};

export default HeaderText;
